module.exports = __webpack_public_path__ + "img/orange_008.5987f185.png";